import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=82a9b636&scoped=true&"
import script from "./Regions.vue?vue&type=script&lang=js&"
export * from "./Regions.vue?vue&type=script&lang=js&"
import style0 from "./Regions.vue?vue&type=style&index=0&id=82a9b636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a9b636",
  null
  
)

export default component.exports